export default __webpack_public_path__ + "static/media/eco-search-icon.67aed0ad.svg";